import type { Campaign, CampaignBriefing } from './campaignsApi';

export type AdChannel = 'meta' | 'google';
export type DestinationType = NonNullable<CampaignBriefing['destinationType']>;

export function campaignChannels(campaign: Partial<Campaign>, briefing?: Partial<CampaignBriefing>): AdChannel[] {
  if (briefing?.adChannels?.length) return briefing.adChannels;
  if (campaign.ad_platform === 'both') return ['meta', 'google'];
  const meta = Boolean(campaign.meta_campaign_id || campaign.meta_ad_account_id);
  const google = Boolean(campaign.google_campaign_id || campaign.google_customer_id
    || ['google', 'google_ads'].includes(campaign.ad_platform || ''));
  return meta && google ? ['meta', 'google'] : google ? ['google'] : ['meta'];
}

export function channelLabel(channel: AdChannel) {
  return channel === 'meta' ? 'Meta Ads' : 'Google Ads';
}

export function channelDestinationError(channels: AdChannel[], destination: DestinationType, url: string) {
  if (!channels.length) return 'Selecione pelo menos um canal de anúncios.';
  if (!channels.includes('google')) return '';
  if (destination === 'lead_form' || destination === 'whatsapp') {
    return 'Google Ads de Pesquisa exige um site ou checkout como destino. Use uma página com formulário ou contato pelo WhatsApp.';
  }
  try {
    if (new URL(url).protocol === 'https:') return '';
  } catch { /* URL incompleta. */ }
  return 'Informe uma URL HTTPS válida para o Google Ads.';
}
